import { IHostApiService } from "services/models/ApiService";
import {
  IHostDashboardLayout,
  IHostEvent,
  IHostEventDetail,
  IHostPlayerTierSumamry,
  IHostPromotion,
  IHostPromotionDetail,
  IHostTrendingCustomerScore,
  IHostTrip,
} from "services/models/Host";
import { IHostActivePlayer } from "services/models/Host/HostActivePlayer";
import { IHostPlayerAudit } from "services/models/Host/HostGuestAudit";
import { IHostPlayer } from "services/models/Host/HostPlayer";
import { IHostReservation } from "services/models/Host/HostReservation";
import { IAbortablePromise } from "utils";
import { mockHostDataStore } from "./host-data";

export class MockHostApiService implements IHostApiService {
  getPromotion(id: string): Promise<IHostPromotionDetail> {
    // throw new Error("Method not implemented.");
    return mockHostDataStore.getPromotion(id);
  }
  getEvent(id: string): Promise<IHostEventDetail> {
    throw new Error("Method not implemented.");
  }
  getTrendingCustomerScore(): IAbortablePromise<IHostTrendingCustomerScore[]> {
    return mockHostDataStore.getCustomerValueScore();
  }
  getReservationByStatus(status: string): IAbortablePromise<IHostReservation[]> {
    return mockHostDataStore.getReservationsByStatus(status);
  }

  getGuestAndHostAudit(): IAbortablePromise<IHostPlayerAudit[]> {
    return mockHostDataStore.getGuestAndHostAudit();
  }

  getActivePlayers(): IAbortablePromise<IHostActivePlayer[]> {
    return mockHostDataStore.getActivePlayers();
  }

  getPlayersBirthday(days?: string): IAbortablePromise<IHostPlayer[]> {
    return mockHostDataStore.getPlayerBirthdays(days);
  }
  getDashboardLayout(): Promise<IHostDashboardLayout[]> {
    return mockHostDataStore.getDashboardLayout();
  }

  getPromotions(): IAbortablePromise<IHostPromotion[]> {
    return mockHostDataStore.getPromotions();
  }

  getEvents(): IAbortablePromise<IHostEvent[]> {
    return mockHostDataStore.getEvents();
  }
  getTrips(value: string): IAbortablePromise<IHostTrip[]> {
    return mockHostDataStore.getTrips(value);
  }

  getPlayerTierSummary(): IAbortablePromise<IHostPlayerTierSumamry> {
    return mockHostDataStore.getPlayerTierSummary();
  }
}
